<template>
  <div class="banner-manage-wrap">
    <el-button
      type="primary"
      :size="$store.state.buttonSize"
      @click="handleFormPopup()"
      style="margin-bottom: 20px"
    >新增</el-button>
    <p style="font-size:12px; color:#666; line-height:22px; padding-bottom:20px">提示：1. 轮播图图片的大小为1200*300（像素）；<br>2. 图片格式包括jpg、png、gif；<br>3. 图片不超过2MB。</p>
    <el-dialog :close-on-click-modal="false" :title="title" width="40%" :visible.sync="dialogVisible" center>
      <div>
        <el-form
          :model="imgForm"
          :size="$store.state.formSize"
          :rules="imgFormRules"
          ref="refImgForm"
          label-width="100px"
        >
          <el-form-item label="图片：">
            <el-upload
              action="#"
              ref="upload"
              class="upload-demo"
              :http-request="handleHttpRequest"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :show-file-list="false"
              list-type="picture"
            >
              <el-button
                :size="$store.state.buttonSize"
                type="primary"
              >选择图片</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="预览：" prop="img">
            <div style="height:150px; width:100%; overflow:hidden">
              <el-image v-if="imgForm.imgPath" style="height:150px" :src="imgForm.imgPath"></el-image>
            </div>
          </el-form-item>
          <el-form-item label="序号：" prop="orderNum">
            <el-input v-model="imgForm.orderNum"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div
        slot="footer"
        style="text-align: center;"
      >
        <el-button type="primary" @click="debounceSubmit" :disabled="isDisabled" :size="$store.state.buttenSize">确 定</el-button>
        <el-button @click="hanleResetFormVals" :size="$store.state.buttenSize">取 消</el-button>
      </div>
    </el-dialog>

    <el-row :gutter="20">
      <el-col
        v-for="item in dataList"
        :key="item.id"
        :md="8"
        :sm="12"
        class="banner-item"
      >
        <el-card
          shadow="hover"
          class="banner-img-card"
          @mouseenter.native="handleMouseEnter(item.id)"
          @mouseleave.native="showIndex = -1"
        >
          <el-image :src="imgSrc(item)"></el-image>
          <div
            v-show="item.id === showIndex"
            class="banner-img-card-mark"
          >
            <div class="banner-card-mark-btns d-flex justify-content-between">
              <el-button type="primary" :size="$store.state.buttenSize" @click="handleFormPopup(item.id)">编辑</el-button>
              <el-button :size="$store.state.buttenSize" @click="imgDel(item.id)">删除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { debounce } from 'throttle-debounce'
import { postWfsImg, wfsImgUrl } from '@/api/common'
import { putNewsimgAdd, getNewsimgList, getNewsimgDetail, postNewsimgEdit, deleteNewsimgDel } from '@/api/newsimg'
const createForm = () => ({
  img: '',
  imgPath: '',
  orderNum: '',
  type: 1
})
export default {
  data() {
    return {
      showIndex: -1,
      dialogVisible: false,
      currentID: null,
      fileList: [],
      dataList: [],
      name: '',
      isDisabled: false,
      imgForm: createForm(),
      imgFormRules: {
        orderNum: [
          { required: true, message: '请输入序号', trigger: 'blur' }
        ],
        imgPath: [
          { required: true, message: '请选择图片', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑轮播图' : '新增轮播图'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.imgSubmit)
  },
  methods: {
    handleHttpRequest(option) {
      const formData = new FormData()
      if (option.data) {
        Object.keys(option.data).forEach(key => {
          formData.append(key, option.data[key])
        })
      }
      formData.append(option.filename, option.file)
      postWfsImg(formData).then(res => {
        if (res.status === 1) {
          this.imgForm.img = res.data.filePath
          this.imgForm.imgPath = wfsImgUrl(res.data.filePath)
        } else {
          this.$message.error(res.msg || '图片上传失败')
        }
      }).catch(() => {
        this.$message.error('图片上传失败')
      })
    },
    handleMouseEnter(index) {
      this.showIndex = index
    },
    // 图片展示地址：WFS 文件名（无路径分隔符）走 /trace/wfs/img，旧 fileupload 数据回退原 imgUrl
    imgSrc(item) {
      if (item.img && item.img.indexOf('/') === -1) {
        return wfsImgUrl(item.img)
      }
      return item.imgUrl
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    // 关闭弹出层
    hanleResetFormVals() {
      this.$set(this, 'imgForm', createForm())
      this.dialogVisible = false
    },
    // 打开弹出层
    handleFormPopup(id) {
      console.log(id)
      const isAdd = !id
      this.dialogVisible = true
      this.$set(this, 'imgForm', createForm())
      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        getNewsimgDetail(id).then(res => {
          if (res.status === 1) {
            this.currentID = res.data.id
            this.imgForm.imgPath = this.imgSrc(res.data)
            this.imgForm.orderNum = res.data.orderNum
            this.imgForm.img = res.data.img
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
            this.isDisabled = false
          }
        })
      }
    },
    imgSubmit() {
      this.$refs.refImgForm.validate(valid => {
        if (!valid) return false
        const submitChange = this.currentID ? postNewsimgEdit : putNewsimgAdd
        submitChange({
          img: this.imgForm.img,
          type: this.imgForm.type,
          orderNum: this.imgForm.orderNum,
          id: this.currentID || undefined
        }).then(res => {
          console.log(res)
          if (res.status === 1) {
            this.dialogVisible = false
            this.currentID ? this.$message.success('编辑成功') : this.$message.success('新增成功')
            this.getNewsimgListData()
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    // 删除用料信息
    imgDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteNewsimgDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除成功')
              this.getNewsimgListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    getNewsimgListData() {
      getNewsimgList({
        page: 1,
        size: 100,
        type: 1
      }).then(res => {
        if (res.status === 1) {
          this.dataList = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getNewsimgListData()
  }
}
</script>

<style lang="scss" scoped>
.banner-manage-wrap {
  .banner-item {
    margin-bottom: 20px;

    .banner-img-card {
      height: 300px;
      position: relative;

      .banner-img-card-mark {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.3);

        .banner-card-mark-btns {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          transform: translateX(-50%) translateY(-50%);
          padding: 0 60px;
        }
      }
    }
  }
}
</style>
